import React from 'react';
import { SearchX } from 'lucide-react';

const EmptyState = ({ message = 'No data matches the current filters' }) => (
  <div className="flex flex-col items-center justify-center py-16 text-gray-400">
    <SearchX size={48} strokeWidth={1.5} />
    <p className="mt-3 text-sm">{message}</p>
    <p className="text-xs mt-1">Try adjusting your filters</p>
  </div>
);

export default EmptyState;
